import React, { useState } from 'react';
import NavButton from '../../components/ul/NavButton';
import { useNavigate } from 'react-router-dom';

const Navbar = ({ selectState }) => {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const navigate = useNavigate();

    const toggleMobileMenu = () => {
        setMobileMenuOpen(!mobileMenuOpen);
    };

    return (
        <nav className="text-main-font w-full p-4 mt-3">
            <div className="flex justify-between items-center">
                {/* Mobile menu button - only visible on small screens */}
                <button
                    className="lg:hidden focus:outline-none"
                    onClick={toggleMobileMenu}
                    aria-label={mobileMenuOpen ? "Close menu" : "Open menu"}
                >
                    {mobileMenuOpen ? (
                        <div className="h-6 w-6 flex items-center justify-center">
                            {/* X icon */}
                            <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round">
                                <line x1="18" y1="6" x2="6" y2="18"></line>
                                <line x1="6" y1="6" x2="18" y2="18"></line>
                            </svg>
                        </div>
                    ) : (
                        <div className="h-6 w-6 flex items-center justify-center">
                            {/* Menu icon */}
                            <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round">
                                <line x1="3" y1="12" x2="21" y2="12"></line>
                                <line x1="3" y1="6" x2="21" y2="6"></line>
                                <line x1="3" y1="18" x2="21" y2="18"></line>
                            </svg>
                        </div>
                    )}
                </button>

                {/* Desktop navigation - hidden on small screens */}
                <ul className="hidden lg:flex space-x-4">
                    <li>
                        <NavButton to="/manage/quiz/add" btnName="Quiz" selectState={selectState === "quizadd"} />
                    </li>
                    <li>
                        <NavButton to="/manage/quiz/show" btnName="Show" selectState={selectState === "quizshow"} />
                    </li>
                    <li>
                        <NavButton to="/manage/quiz/nonstop" btnName="Non Stop" selectState={selectState === "nonstop"} />
                    </li>
                    <li>
                        <NavButton to="/manage/quiz/wrong" btnName="Wrong Ans" selectState={selectState === "wrong"} />
                    </li>
                    .  <li>
                        <NavButton to="/manage/quiz/daily/streak/earn" btnName="Daily Streak" selectState={selectState === "streak"} />
                    </li>
                    <li>
                        <NavButton to="/manage/quiz/read/earn" btnName="Read And Earn" selectState={selectState === "read"} />
                    </li>
                    <li>
                        <NavButton to="/manage/quiz/tap/earn" btnName="Tap To Earn" selectState={selectState === "tap"} />
                    </li>
                    <li>
                        <NavButton to="/manage/quiz/whois/earn" btnName="Who is Beautiful" selectState={selectState === "whois"} />
                    </li>
                    <li>
                        <NavButton to="/manage/quiz/ad/earn" btnName="Ads Earn" selectState={selectState === "adsEarn"} />
                    </li>
                </ul>

            </div>

            {/* Mobile navigation - only shown when menu is open */}
            {mobileMenuOpen && (
                <div className="lg:hidden mt-4 bg-white shadow rounded-lg p-4">
                    <ul className="flex flex-col space-y-2">
                        <li>
                            <NavButton to="/manage/quiz/add" btnName="Quiz" selectState={selectState === "quizadd"} />
                        </li>
                        <li>
                            <NavButton to="/manage/quiz/show" btnName="Show" selectState={selectState === "quizshow"} />
                        </li>
                        <li>
                            <NavButton to="/manage/quiz/nonstop" btnName="Non Stop" selectState={selectState === "nonstop"} />
                        </li>
                        <li>
                            <NavButton to="/manage/quiz/wrong" btnName="Wrong Ans" selectState={selectState === "wrong"} />
                        </li>
                        <li>
                            <NavButton to="/manage/quiz/daily/streak/earn" btnName="Daily Streak" selectState={selectState === "streak"} />
                        </li>
                        <li>
                            <NavButton to="/manage/quiz/read/earn" btnName="Read And Earn" selectState={selectState === "read"} />
                        </li>
                        <li>
                            <NavButton to="/manage/quiz/tap/earn" btnName="Tap To Earn" selectState={selectState === "tap"} />
                        </li>
                        <li>
                            <NavButton to="/manage/quiz/whois/earn" btnName="Who is Beautiful" selectState={selectState === "whois"} />
                        </li>
                        <li>
                            <NavButton to="/manage/quiz/ad/earn" btnName="Ads Earn" selectState={selectState === "adsEarn"} />
                        </li>
                    </ul>
                </div>
            )}
        </nav>
    );
};

export default Navbar;